module.exports = __webpack_public_path__ + "images/ico-task.svg?617cec7640c3f3973ced9ab03ab583ef";